"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _material = require("@mui/material");
var _reactQuery = require("@tanstack/react-query");
var _reactQueryDevtools = require("@tanstack/react-query-devtools");
var _Router = require("pages/Router");
var _muiThemeConfig = require("util/config/muiThemeConfig");
var _PermissionsContext = require("./context/PermissionsContext");
var _TeamsAndChannelsContext = require("./context/TeamsAndChannelsContext");
require("./css/app.css");
require("./css/global.css");
require("./css/modals.css");
require("./css/navbar.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var queryClient = new _reactQuery.QueryClient();
function App() {
  return /*#__PURE__*/_react["default"].createElement(_reactQuery.QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/_react["default"].createElement(_PermissionsContext.PermissionsProvider, null, /*#__PURE__*/_react["default"].createElement(_TeamsAndChannelsContext.TeamsAndChannelsProvider, null, /*#__PURE__*/_react["default"].createElement(_react2.ThemeProvider, {
    theme: _muiThemeConfig.theme
  }, /*#__PURE__*/_react["default"].createElement(_material.CssBaseline, null), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "App",
    style: {
      width: "100vw",
      height: "calc(100vh - 64px - 52px)",
      backgroundColor: "#F8F8F8"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Router.Router, null)), /*#__PURE__*/_react["default"].createElement(_reactQueryDevtools.ReactQueryDevtools, {
    initialIsOpen: false
  })))));
}
function AppWrapper() {
  return /*#__PURE__*/_react["default"].createElement(App, null);
}
var _default = exports["default"] = AppWrapper;